import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "./Brand";
import { Phone, MapPin } from "lucide-react";
import { BUSINESS_CONTACT as BC } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <BrandMark inverted />
          <p className="mt-5 max-w-md text-sm text-white/70 leading-relaxed">
            Pre-settlement legal funding built by an attorney. Fair rates, settlement-first underwriting, zero friction for plaintiffs and law firms.
          </p>
          <div className="mt-6 space-y-2.5 text-sm text-white/80" data-testid="footer-contact">
            <a href={BC.tel} className="flex items-center gap-2.5 hover:text-white transition-colors" data-testid="footer-phone-link">
              <Phone className="w-4 h-4 text-[#0066FF]" /> {BC.phoneDisplay}
            </a>
            <a href={BC.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2.5 hover:text-white transition-colors" data-testid="footer-address-link">
              <MapPin className="w-4 h-4 text-[#0066FF] mt-0.5" /> <span>{BC.street}, {BC.city}, {BC.region} {BC.postalCode}</span>
            </a>
          </div>
          <div className="mt-6">
            <Link to="/apply">
              <button className="bg-white text-[#0A2540] hover:bg-[#0066FF] hover:text-white rounded-full px-6 h-11 text-sm font-semibold transition-colors">Apply now →</button>
            </Link>
          </div>
        </div>
        <FooterCol title="For plaintiffs" links={[
          { to: "/how-it-works", l: "How it works" },
          { to: "/services/pre-settlement", l: "Pre-settlement funding" },
          { to: "/states/ohio", l: "Ohio funding" },
          { to: "/faq", l: "FAQ" },
        ]} />
        <FooterCol title="For attorneys" links={[
          { to: "/for-attorneys", l: "Why attorneys switch" },
          { to: "/services/attorney-lending", l: "Attorney lending" },
          { to: "/services/litigation-finance", l: "Litigation finance" },
          { to: "/services/medical-funding", l: "Medical funding" },
        ]} />
        <FooterCol title="Company" links={[
          { to: "/about", l: "About Adam" },
          { to: "/states", l: "States we cover" },
          { to: "/blog", l: "Blog" },
          { to: "/contact", l: "Contact" },
        ]} />
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Instabridge Funding. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Privacy</span>
            <span>Terms</span>
            <span>Disclosures</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div>
    <div className="uppercase-label text-white/50 mb-4">{title}</div>
    <ul className="space-y-2.5 text-sm text-white/80">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="hover:text-white transition-colors">{l.l}</Link>
        </li>
      ))}
    </ul>
  </div>
);
